import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './access/login/login.component';
import { AssociationAccessComponent } from './access/association-access/association-access.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    // { path: 'request-time', component: RequestTimeComponent },
    { path: 'access', component: AssociationAccessComponent },
    {
      path: 'd',
      loadChildren: () => import ('./dashboard/dashboard.module').then( (m) => m.DashboardModule ),
    },
  ]
;

@NgModule( {
  imports: [ RouterModule.forRoot( routes, { relativeLinkResolution: 'legacy' } ) ],
  exports: [ RouterModule ],
} )
export class AppRoutingModule {
}
